import { render, staticRenderFns } from "./AccountActivate.vue?vue&type=template&id=238d755e&scoped=true&lang=html"
import script from "./AccountActivate.vue?vue&type=script&lang=js"
export * from "./AccountActivate.vue?vue&type=script&lang=js"
import style0 from "./AccountActivate.vue?vue&type=style&index=0&id=238d755e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d755e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238d755e')) {
      api.createRecord('238d755e', component.options)
    } else {
      api.reload('238d755e', component.options)
    }
    module.hot.accept("./AccountActivate.vue?vue&type=template&id=238d755e&scoped=true&lang=html", function () {
      api.rerender('238d755e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/AccountActivate.vue"
export default component.exports